
import Orders from "./component";
import { toast } from 'react-toastify';
import { useCallback, useEffect, useState } from "react";
import OrderDeatails from "./component";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import { API_BASE_URL } from "../../config";
import ServerErrorPage from "../../ServerError/ServerErrorPage";
const OrderDeatailsContainer = (props) => {

  const { makeApiRequest } = useApiRequest()
  const token = localStorage.getItem("UserJWTAuth");
  const deviceId = localStorage.getItem("uuid");
  const [orderdetail, setOrderdetail] = useState('')


  const [loader, setLoader] = useState(false)
    const [serverError,      setServerError]      = useState(false);
  const { orderId } = useParams()
  const navigate = useNavigate()
  useEffect(() => {
    fetchOrderDetails()
  }, [])
  const UserJWTAuth = localStorage.getItem('UserJWTAuth');
  useEffect(() => {

    ///console.log("UserJWTAuth BusinessPaymentContainer",UserJWTAuth)
    if (!UserJWTAuth) {
      navigate('/')
    }
  }, [])

  useEffect(() => {

  }, [])
  const totalAmount = orderdetail && orderdetail?.lineItems && orderdetail?.lineItems.reduce((accumulator, item) => accumulator + item.offerPrice * item.unitCount, 0);
  //console.log("totalAmount",totalAmount)

    const handleServerError = useCallback((error) => {
      console.log("Error response for debugging:", error.response.status);
    const statusCode = error?.response?.data?.status?.code;
  
    if (
      statusCode === "INTERNAL_SERVER_ERROR" ||
      error?.response?.status === 500|| error.response.status === 502
    ) {
      console.log("Server Error:", statusCode);
  
      setServerError(true); // 👈 state create karo
      setLoader(false);
      return true;
    }
  
    return false;
  }, []);

  const fetchOrderDetails = () => {
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");




    makeApiRequest({
     
      url: `${API_BASE_URL}/consumerbe/api/v2/order/${orderId}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId,
      },
      data: {
        request: {}
      },
      handleSuccess: (res) => {
        //console.log("✅ Payment Initiated Successfully:", res);
        handleResponseOrderDetails(res);
      },
      handleError: (err) => {
          if(handleServerError(err)) return
        //console.error("❌ Payment Initiation Failed:", err);
        handleErrorOrderDetails(err);
      },
    });

  };


  const handleErrorOrderDetails = (error) => {
    //console.log("res")
    setLoader(false)
    if (error?.response?.status == 401 || error?.response?.status == 403) {

      //console.log("khan handleErrorVmInventory", error.response.data.status.code);
      //Logout
      //localStorage.removeItem("UserJWTAuth")
      navigate("/login");
    }
    else {
      toast.error(`${error?.response?.data?.status?.code}`, {
        position: "top-right",
        autoClose: 1000,
      });
    }
  }

  const handleResponseOrderDetails = (res) => {
    //console.log("handleResponseOrderDetails",res)
    setLoader(false)
    setOrderdetail(res?.data?.data)
  }

  if(serverError) return <ServerErrorPage/>




  return (
    <OrderDeatails
      orderdetail={orderdetail}
      totalAmount={totalAmount}
      orderId={orderId}
    />
  )


}




export default OrderDeatailsContainer